import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTenantListApi } from 'hooks/useTenantListApi';
import { StandardListPage } from 'components/StandardListPage';
import { apiUrl } from 'utils/apiUrl';
import { TenantData, TenantSearchableResponse } from 'App.types';
import { AddTenantButton } from './AddTenantButton';
import { RefreshTenantListButton } from './RefreshTenantListButton';
import { TenantListTable } from '../../components/TenantList';

export const TenantList: React.FunctionComponent = (props) => {
  const { data, error, loading, fetch } = useTenantListApi<TenantSearchableResponse>(
    apiUrl('tenancy', 'tenants/searchable'),
  );
  const { t } = useTranslation();

  React.useEffect(() => {
    // Manually fetch on each initial render to avoid stale data
    fetch().catch(() => {
      // Handled through useTenantListApi `error`
    });
  }, [fetch]);

  const tenants = React.useMemo<TenantData[]>(() => data?.results ?? [], [data]);

  return (
    <StandardListPage
      title={t('tenantList.pageTitle')}
      headerControl={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <RefreshTenantListButton onRefresh={() => fetch(true)} loading={loading} />
          <AddTenantButton />
        </div>
      }
      data-testid="tenant-list-page"
      loading={false}
      error={undefined}
    >
      <TenantListTable
        searchText={t('tenantList.searchLabel')}
        tenants={tenants}
        error={error}
        loading={loading}
        {...props}
      />
    </StandardListPage>
  );
};
